module.exports = __webpack_public_path__ + "static/img/003城市名片3.92ac5b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/003城市名片3.jpg
// module id = ChGm
// module chunks = 0